var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"timeout":"6000","top":"","right":"","color":_vm.showCol},model:{value:(_vm.showSnack),callback:function ($$v) {_vm.showSnack=$$v},expression:"showSnack"}},[_vm._v(" "+_vm._s(_vm.showMsg)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }